module.exports = __webpack_public_path__ + "img/customers_apps@3x.e4dadf6a.png";